import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "assets/logo.png";
import { Button, Container, Form, Navbar } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { login } from "api/auth";
import { useAuthStore } from "../../zustand/loginStore";


/**
 * Login component
 */
const Login: React.FC = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const { setToken, setRole } = useAuthStore();
  const navigate = useNavigate();

  /**
   * Effect for error timeout
   */
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        setError(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  /**
   * Handle login action
   */
  const handleLogin = async () => {
    try {
      const response = await login(username, password);

      if (response.success) {
        localStorage.setItem("token", response.token);
        setToken(response.token);
        setRole(response.role);
        navigate("/dashboard");
      } else {
        setError(true);
        setUsername("");
        setPassword("");
      }
    } catch (error) {
      setError(true);
      setUsername("");
      setPassword("");
    }
  };

  const handleForgotPassword = () => {
    navigate("/recuperar-contrasena");
  };

  const handleFocus = () => {
    setError(false);
  };

  return (
    <>
      <Navbar className="bg-custom-yellow" style={{ padding: 0 }} expand="lg">
        <Container fluid style={{ height: "60px" }}>
          <Navbar.Brand href="#" className="ms-3">
            <img
              src={logo}
              alt="Logo de la Boutique"
              style={{ width: "50px" }}
            />
          </Navbar.Brand>
        </Container>
      </Navbar>
      <div className="container d-flex flex-column align-items-center justify-content-start min-vh-100 pt-5">
        <img
          src={logo}
          alt="Logo de la Boutique"
          className="mb-4"
          style={{ width: "215px" }}
        />
        <div className="w-100" style={{ maxWidth: "400px" }}>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <h1 className="text-center mb-4 fw-bold">Iniciar Sesión</h1>

              <Form.Control
                type="text"
                placeholder="Correo electrónico"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onFocus={handleFocus}
                className={`mx-auto ${error ? "is-invalid" : ""}`}
                style={{ width: "55%" }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    document.getElementById("password-input")?.focus();
                  }
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Control
                id="password-input"
                type="password"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onFocus={handleFocus}
                className={`mx-auto ${error ? "is-invalid" : ""}`}
                style={{ width: "55%" }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleLogin();
                  }
                }}
              />
              {error && (
                <div className="text-danger mt-2 text-center">
                  Correo electrónico o contraseña incorrectos
                </div>
              )}
            </Form.Group>

            <div className="d-flex justify-content-center">
              <Button
                variant="primary"
                type="button"
                onClick={handleLogin}
                className="mt-4 fw-bold"
                style={{ width: "30%" }}
              >
                Continuar
              </Button>
            </div>
            <Button
              variant="link"
              onClick={handleForgotPassword}
              className="w-100 text-center"
              style={{ textDecoration: "none" }}
            >
              Olvidé mi contraseña
            </Button>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Login;
